import OpsUserFormLayout from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<OpsUserFormLayout />} />
